import { render, staticRenderFns } from "./PatientMarsAlertsRep.vue?vue&type=template&id=3dbfbce0&"
import script from "./PatientMarsAlertsRep.vue?vue&type=script&lang=js&"
export * from "./PatientMarsAlertsRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientMarsAlertsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports